/**
 * Query key factory for labour group queries
 * Following react-query-patterns.md
 *
 * Ensures consistent cache invalidation when:
 * - Creating new labour groups
 * - Updating labour groups
 * - Deleting labour groups
 * - Assigning labour items to groups
 */
export const labourGroupKeys = {
  all: ['labourGroups'] as const,
  lists: () => [...labourGroupKeys.all, 'list'] as const,
  details: () => [...labourGroupKeys.all, 'detail'] as const,
  detail: (groupId: string) => [...labourGroupKeys.details(), groupId] as const,
};
